import React from 'react'
import Chart from 'react-apexcharts'
import ChartCard from './ChartCard'
import { formatCurrency } from '../mockData'

export default function CashFlowAreaChart({ data }) {
    const options = {
        chart: {
            type: 'area',
            toolbar: { show: false },
            animations: { enabled: true, easing: 'easeinout', speed: 800 },
        },
        xaxis: {
            categories: data.categories,
            labels: { style: { colors: '#64748B', fontSize: '12px' } },
        },
        yaxis: {
            labels: {
                style: { colors: '#64748B', fontSize: '12px' },
                formatter: (val) => `R$ ${(val / 1000).toFixed(0)}k`,
            },
        },
        stroke: {
            curve: 'smooth',
            width: [3, 3],
            dashArray: [0, 6],
        },
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.35,
                opacityTo: 0.05,
                stops: [0, 100],
            },
        },
        colors: ['#3B82F6', '#93C5FD'],
        legend: {
            position: 'top',
            horizontalAlign: 'right',
            labels: { colors: '#64748B' },
        },
        tooltip: {
            theme: 'light',
            y: {
                formatter: (val) => val != null ? formatCurrency(val) : '—',
            },
        },
        annotations: {
            xaxis: data.todayIndex != null ? [{
                x: data.categories[data.todayIndex],
                borderColor: '#64748B',
                strokeDashArray: 4,
                label: {
                    text: 'Hoje',
                    borderColor: '#64748B',
                    style: { color: '#fff', background: '#64748B', fontSize: '11px', padding: { left: 6, right: 6, top: 2, bottom: 2 } },
                },
            }] : [],
        },
        grid: {
            borderColor: '#E2E8F0',
            strokeDashArray: 4,
        },
        dataLabels: { enabled: false },
    }

    const series = [
        { name: 'Realizado', data: data.realizado },
        { name: 'Projetado', data: data.projetado },
    ]

    return (
        <ChartCard title="Fluxo de Caixa" subtitle="Realizado vs. Projetado (saldo acumulado)">
            <Chart options={options} series={series} type="area" height={320} />
        </ChartCard>
    )
}
